import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { Link, useHistory } from 'react-router-dom';
import { Typography, Button } from '@material-ui/core';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import OpenInNew from '@material-ui/icons/OpenInNew';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import { CustomTable, FilterPlaceholder } from '../../common/CustomTable';
import permissionCheck from '../../util/PermCheck';

const columns = [
  {
    Header: 'Contact Name',
    accessor: 'Name',
    Filter: FilterPlaceholder,
  },
  {
    Header: 'First Name',
    accessor: 'FirstName',
    width: 80,
  },
  {
    Header: 'Last Name',
    accessor: 'LastName',
    width: 80,
  },
  {
    Header: 'Email',
    accessor: 'Email',
  },
  {
    Header: 'Phone',
    accessor: 'Phone',
    width: 60,
  },
  {
    Header: 'Agent',
    accessor: d => (d.IsAgent ? 'Yes' : 'No'),
    id: 'isAgent',
    width: 45,
  },
  {
    width: 40,
    Cell: ({ row }) => (
      <a
        onClick={e => e.stopPropagation()}
        href={`/contacts/${row.original.ContactId}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'block',
          width: '100%',
          height: '100%',
          color: '#666',
        }}
      >
        <OpenInNew />
      </a>
    ),
    id: 'newTab',
  },
];

const Contacts = () => {
  const { dataStore } = useRootStore();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const contacts = dataStore.contactArray;
  const canEdit = permissionCheck('CONTACT_M');

  useEffect(() => {
    const initialize = async () => {
      if (contacts.length === 0) {
        await dataStore.retrieveContacts();
      }
      setLoading(false);
    };
    initialize();
  }, []);
  if (isLoading) return <Spinner />;
  return (
    <Observer
      render={() => {
        return (
          <FlexDiv>
            <WideBox style={{ maxWidth: '1500px', width: '98%' }}>
              <CustomTable
                data={contacts}
                columns={columns}
                minRows={1}
                trClassName="react-table-hover-row"
                getTrProps={({ row }) => ({
                  onClick: () =>
                    canEdit &&
                    history.push(`/contacts/${row.original.ContactId}`),
                })}
                tableHeader={<Typography variant="h2">Contacts</Typography>}
                actionables={
                  permissionCheck('CONTACT_I') && (
                    <Button
                      variant="outlined"
                      color="primary"
                      component={Link}
                      to="/contacts/new"
                    >
                      <CirclePlusIcon
                        style={{ marginRight: '4px', marginLeft: '-3px' }}
                      />
                      New Contact
                    </Button>
                  )
                }
                containerStyle={{ padding: '0 2rem' }}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default Contacts;
